import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=f5f28fa0&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
import style0 from "./Main.vue?vue&type=style&index=0&id=f5f28fa0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f28fa0",
  null
  
)

export default component.exports